class DeviceFingerprintService {
    private readonly _deviceOptions: any /*Options*/ = {
        excludes: {
            userAgent: true,
            webdriver: true,

            language: true,
            // colorDepth: true,

            deviceMemory: true, // solo chrome lo valorizza

            // pixelRatio: true, //ie
            // hardwareConcurrency: true, //	 not supported by IE
            // screenResolution: true, // ie
            availableScreenResolution: true, // edge diverso
            // timezoneOffset: true,
            // timezone: true, // ie

            sessionStorage: true,
            localStorage: true,
            indexedDb: true,
            addBehavior: true,
            openDatabase: true,

            // cpuClass: true, // ie
            // platform: true,

            doNotTrack: true,
            plugins: true,
            canvas: true,
            webgl: true,

            webglVendorAndRenderer: true, // in ff e chrome corrisponde

            adBlock: true,

            // hasLiedLanguages: true,
            // hasLiedResolution: true,
            // hasLiedOs: true,
            // hasLiedBrowser: true,
            // touchSupport: true,

            fonts: true,
            fontsFlash: true,
            audio: true,
            enumerateDevices: true
        }
    };
    private _deviceFingerprint: string;

    onDeviceFingerprintUpdate: (deviceFingerprint: string) => void;

    private storeFingerprint(components: Fingerprint2.Component[]): void {
        // console.log(components); // an array of components: {key: ..., value: ...}

        var values = components.map(component => component.value);
        this._deviceFingerprint = Fingerprint2.x64hash128(values.join(""), 31);

        if (!!this.onDeviceFingerprintUpdate) {
            this.onDeviceFingerprintUpdate(this._deviceFingerprint);
        }
    };

    initialize(): void {
        if (window.requestIdleCallback) {
            requestIdleCallback(() => {
                Fingerprint2.get(this._deviceOptions, cmp => this.storeFingerprint(cmp));
            });
        } else {
            setTimeout(() => {
                Fingerprint2.get(this._deviceOptions, cmp => this.storeFingerprint(cmp));
            }, 50);
        }
    }

    getDeviceFingerprint(): string {
        return this._deviceFingerprint;
    }

}   

//$.fn.greenify = function() {
//    this.css( "color", "green" );
//};